import styles from "./styles.module.scss";
import React, { useEffect } from "react";
import useCollapse from "react-collapsed";
import { Link } from "react-router-dom";

function Collapsible() {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({ duration: 1000 });
    return (
        <div className={styles.collapsible}>
            <div className={styles.header} {...getToggleProps()}>
                <p>{isExpanded ? '-' : '+'}</p>
                <text>Technique de référencement</text>
            </div>
            <div {...getCollapseProps()}>
                <div className={styles.content}>
                    <b>OrgaExpert</b> vous offre les meilleures solutions de référencement qui incluent toutes les techniques qui
                    permettent d’améliorer votre site et sa réputation, Une série de techniques et d’outils sont
                    mises en place pour un bon référencement : <br /> <br />
                    <p>Rechercher et identifier les mots clés pertinents pour votre activité.</p>
                    <p>Améliorer les éléments On-Page : le contenu de vos pages, les titres, les descriptions, les URLs, les images, les liens internes, etc.</p>
                    <p>Développer les éléments Off-Page : les liens entrants, anchor texts, les réseaux sociaux, etc.,</p>
                    <p>Suivi, Analyse des résultats, et optimisation.</p>
                </div>
            </div>
        </div>
    );
}
function Collapsible2() {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({ duration: 1000 });
    return (
        <div className={styles.collapsible}>
            <div className={styles.header} {...getToggleProps()}>
                <p>{isExpanded ? '-' : '+'}</p>
                <text>Avantages du référencement</text>
            </div>
            <div {...getCollapseProps()}>
                <div className={styles.content}>
                    Le référencement n’est pas une simple option mais une véritable nécessité, une récente enquête a révélé que plus de
                    80 % des entreprises utilisent le web pour trouver leurs fournisseurs et leurs produits. Il est donc vital pour votre
                    entreprise de renforcer votre présence sur internet afin de figurer aux côtés de vos concurrents voire devant eux.<br /><br />

                    Dans notre société, nos services s’adressent à tous les sites qui se trouvent face à un problème de positionnement dans
                    les résultats de recherche Google ou qui ont besoin atteindre ou de conserver une place de choix dans les moteurs de recherche.
                </div>
            </div>
        </div>
    );
}

function Intro() {
    useEffect(() => {
        window.scrollTo(0, 1000)
    }, [])

    return (
        <>
            <section className={styles.container}>
                <div className={styles.title}>
                    <text>Search engine optimisation</text>
                    <p>pour la réussite de vos projets</p>
                </div>
                <div className={styles.bigbox}>

                    <div className={styles.service}>
                        <div className={styles.bigText}>SEO</div>
                        <div className={styles.paragraph}>
                            Si vous souhaitez accroître votre visibilité sur le web, vous ne devrez pas vous contenter de ces quelques visites qui proviennent d’une simple saisie de votre URL sur la barre d’adresse du navigateur.
                            <br /><br />
                            Cela dit, vous devrez absolument penser à votre apparition ou plus spécifiquement votre positionnement dans les pages des résultats de recherche et notamment les recherches qui concernent votre secteur d’activité. Pour y arriver, il n’y a qu’un seul moyen : le SEO.
                            <br /><br />
                            Le SEO (Search Engine Optimization) ou l’optimisation pour les moteurs de recherche revient à appliquer les techniques de référencement naturel dans le but de faire apparaître vos pages de site web dans les premières positions des SERPs (Search Engine Result Page).
                            <br /><br />
                            Compétents, les référenceurs de OrgaExpert vous accompagnent dans le référencement de votre site web et assurent un résultat optimal pour votre visibilité sur les SERPs.
                            <br /><br />
                            Les techniques de référencement naturel tournent toutes autour de deux axes majeurs : répondre aux besoins des internautes et s’adapter au fonctionnement des algorithmes des moteurs de recherche.
                            <br /><br />
                            Dans ce cadre, nous intervenons pour l’analyse des besoins de vos clients potentiels tout en gardant nos yeux sur les dernières mises à jour des algorithmes des moteurs de recherche.
                        </div>
                    </div>


                    <div className={styles.expandable}>
                        <Collapsible />
                        <Collapsible2 />
                    </div>

                </div>
                <div className={styles.title}>
                    <div className={styles.text2}>Autre services</div>
                </div>
                <div className={styles.bigbox2}>
                    <Link to="/services/developpementMobile">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>Développement Mobile</div>
                            <img src="/icons/smartphone.png" alt="web dev" />
                        </div>
                    </Link>
                    <Link to="/services/developpementWeb">
                    <div className={styles.service1}>
                        <div className={styles.bigText}>Développement Web</div>
                        <img src="/icons/desktop.png" alt="web dev" />
                    </div>
                    </Link>
                    <Link to="/services/e_commerce">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>E-COMMERCE ET MARKETPLACES</div>
                            <img src="/icons/e-commerce.png" alt="web dev" />

                        </div>
                    </Link>
                    <Link to="/services/transformation_digital">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>CONSEIL ET STRATÉGIE</div>
                            <img src="/icons/assist.png" alt="web dev" />

                        </div>
                    </Link>
                    <Link to="/services/erp">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>INTÉGRATION ERP</div>
                            <img src="/icons/integration.png" alt="web dev" />

                        </div>
                    </Link>
                </div>
            </section>
        </>
    )
}

export default Intro;